import React from "react"
import { Button } from "react-bootstrap"
import Calendar from "../Calendar/Calendar"


export default function Home() {
  return (
    <div style={{ width: "100%" }}>
      <div style={{ width: "min(980px, 100%)", margin: "0 auto" }}>
        <br />

        <div
          style={{
            padding: "16px",
            borderRadius: "5px",
            marginBottom: "20px",
            textAlign: "left",
            fontSize: "18px",
            fontFamily: "Arial, Helvetica, sans-serif",
            maxWidth: "min(900px, 100%)",
            margin: "0 auto",
          }}
        >
          The Broadway Maven is an educational community that helps its members
          think more deeply about musical theater. Every month, members may attend
          5-15 expert-led classes and innovative Broadway experiences, all for
          just $25. We also foster enthusiasm for Broadway through the FREE weekly
          substack newsletter{" "}
          <a
            href="https://thebroadwaymaven.substack.com/"
            target="_blank"
            rel="noreferrer"
            style={{ color: "#007bff", textDecoration: "none" }}
          >
            {" "}
            <em>MARQUEE</em>
          </a>{" "}
          and host an expansive{" "}
          <a
            href="https://www.youtube.com/c/DavidBenkofTheBroadwayMaven"
            target="_blank"
            rel="noreferrer"
            style={{ color: "#007bff", textDecoration: "none" }}
          >
            YouTube channel
          </a>
          . It's your home for Broadway appreciation.
        </div>
        <br />

        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            style={{ backgroundColor: "#7756e3", borderRadius: "10px" }}
            variant="outlined"
            size="large"
          >
            <a
              style={{
                fontSize: "26px",
                textDecoration: "none",
                color: "white",
              }}
              rel="noreferrer"
              target="_blank"
              href="https://thebroadwaymaven.substack.com/subscribe"
            >
              Join The Broadway Maven
            </a>
          </Button>
        </div>

        <br />
        <br />

        {/* Calendar is already responsive via bm-embedCalendar */}
        <Calendar />

        {/* <div className="bm-embed">
          <iframe
            title="David Benkof Video"
            src="https://www.youtube.com/embed/YxaYYq3hJ64?si=Bjg1ZoVvGPg38JVi&autoplay=0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div> */}

        <br />
      </div>
    </div>
  )
}
